/**
 * Method to call V&G communication privacy service
 * @param {*} component
 * @param {*} ProfileService
 */
let callPrivacy=(component, ProfileService)=>{
    component.firstUpLine = false;
    ProfileService.getPrivacySettings().then(function (response) {
        component.setPrivacy(response.data.status);
    }).catch(function (error) {
    });
}

/**
 * Method to call V&G order privacy service.
 * @param {*} component
 * @param {*} ProfileService
 */

let callOrderPrivacy = (component, ProfileService)=>{
    let self = component;
    ProfileService.getOrderPrivacyPreferences()
        .then(response => {
            if (response.data.privacy.orderSubscription.length === 0) {
                self.noDataFromService = true;
            } else {
                self.setOrderPrivacy(response.data.privacy.orderSubscription);
            }
        })
        .catch(error => {
            self.noDataFromService = true;
        })
}

export default {
    callPrivacy:callPrivacy,
    callOrderPrivacy:callOrderPrivacy
};
